import { Dialog } from '@strata/react-dialog';
import { ComponentProps } from 'react';

interface MedicalBillingAttestationDialogProps {
    isOpen: boolean;
    onPrimaryButtonClick: ComponentProps<typeof Dialog>['onPrimaryButtonClick'];
    onSecondaryButtonClick: ComponentProps<typeof Dialog>['onSecondaryButtonClick'];
}

export const MedicalBillingAttestationDialog = ({
    isOpen,
    onPrimaryButtonClick,
    onSecondaryButtonClick,
}: MedicalBillingAttestationDialogProps) => (
    <Dialog
        dialogTitle="Medical Billing Attestation"
        isOpen={isOpen}
        primaryButtonLabel="Attest And Submit"
        onPrimaryButtonClick={onPrimaryButtonClick}
        secondaryButtonLabel="Cancel"
        onSecondaryButtonClick={onSecondaryButtonClick}
        dialogContent={
            <div>
                By submitting this claim, I attest that the information submitted is free of any
                misrepresentation or any false, incomplete, or otherwise misleading information.
                Further, the submission of this claim and the information contained herein is
                consistent with the terms of the Free Market Health Participating Provider
                Marketplace Agreement.
            </div>
        }
    />
);
